/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IUor, IUser } from "../shared/interfaces";

const controller = 'Uors';



const getOrganigrammaAoo = (aooId: number, cancelToken?: CancelToken): Promise<IUor[]> => {
    return axiosInstance.get(`${controller}/${aooId}/GetOrganigramma`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getOrganigrammaFlat = (aooId: number, cancelToken?: CancelToken): Promise<IUor[]> => {
    return axiosInstance.get(`${controller}/${aooId}/GetOrganigrammaFlat`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getUorSuggestionsForCurrentUser = (aooId: number, text: string, cancelToken?: CancelToken): Promise<IUor[]> => {
    return axiosInstance.get(`${controller}/${aooId}/GetUorSuggestionsForCurrentUser/${text}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const addUor = (aooId: number, uor: Partial<IUor>, cancelToken?: CancelToken): Promise<IUser> => {
    return axiosInstance.post(`${controller}/${aooId}/Add`, uor, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateUor = (aooId: number, id: number, uor: Partial<IUor>, cancelToken?: CancelToken): Promise<IUser> => {
    return axiosInstance.post(`${controller}/${aooId}/Update/${id}`, uor, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const deleteUor = (aooId: number, id: number, cancelToken?: CancelToken): Promise<IUser> => {
    return axiosInstance.post(`${controller}/${aooId}/Delete/${id}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}



export default {
    getOrganigrammaAoo,
    getOrganigrammaFlat,
    getUorSuggestionsForCurrentUser,
    addUor,
    updateUor,
    deleteUor,
}
